import { isSuperadmin } from "../../utils/permissions";
import { Box, Typography, Input } from "@mui/joy";

const TotalCartBox = ({
    discount,
    selected,
    orgData,
    calculateFinalPrice,
    currentExtraAddons,
    calculateFinalPriceAddon,
    calculateDiscountAddon,
    calculateNet,
    upgradeDiscount,
    addons
}) => {
    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                gap={1}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography level="body-md">Sconto</Typography>
                    <Input
                        size="sm"
                        type="number"
                        min={0}
                        value={discount.manualDiscount.state}
                        onChange={(e) =>
                            discount.manualDiscount.set(
                                parseFloat(e.target.value) || 0
                            )
                        }
                        endDecorator={<Typography>€</Typography>}
                        sx={{ maxWidth: 120 }}
                        disabled={!isSuperadmin()}
                    />
                </Box>

                {discount.calculate() > 0 && (
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-end"
                        gap={0.5}
                    >
                        {selected && selected.id > orgData?.licence && (
                            <Typography level="body-sm" color="success">
                                Sconto upgrade pacchetto: {upgradeDiscount().toFixed(2)}€
                            </Typography>
                        )}
                        {true && (
                            <Typography level="body-sm" color="success">
                                Sconto mezzi rimborsati: {calculateDiscountAddon(addons.state[0].price_amount).toFixed(2)}€
                            </Typography>
                        )}
                        <Typography level="body-md" fontWeight="lg">
                            Totale sconto: {discount.calculate().toFixed(2)}€
                        </Typography>
                    </Box>
                )}

                <Box display="flex" alignItems="center" gap={1}>
                    <Typography level="body-md">Totale:</Typography>
                    {
                        <Typography level="body-md" fontWeight="lg">
                            {Number(
                                calculateNet()).toFixed(2)}
                            €
                        </Typography>
                    }
                </Box>
            </Box>
        </>
    );
};

export default TotalCartBox;
